import {
    SET_GDC, SET_SUBJECT, SET_TOPIC, SET_CONDITION, SET_AUTHORIZE, SET_USER, SET_AMOUNT, SET_TYPE, SET_DOA, SET_SEARCH, SET_ACTION, SET_BOOK, SET_SEARCH_NAME, SET_ORG, SET_BOOK_DETAIL, SET_QUERY,
    SET_SELECTED_TOPIC, RESET_DOA
} from '../actions/types';

const INIIAL_STATE = {
    gdc: 'CORPORATE',
    queryBook: {},
    queryBookList: [],
    queryTopicList: [],
    queryConditionList: [],
    queryBookArr: [],
    subjectList: [],
    topicList: [],
    conditionList: [],
    orgList: [],
    authorize: [],
    bookReleaseList: [],
    selectedBookRelease: {},
    user: {},
    action: 'authorize',
    amount: '',
    type: 'อำนาจทั่วไป / General',
    bookCode: '',
    bookDetail: {
        comCode: '',
        orgId: ''
    },
    doa: {
        levelOne: '',
        levelTwo: '',
        levelThree: '',
        levelFour: '',
        levelFive: '',
        levelSix: '',
        levelSeven: ''
    },
    selectedTopic: {},
    selectedCondiiton: {},
    search: '',
    name: '',
    queryDoaList: [],
}

export default (state = INIIAL_STATE, action) => {
    switch (action.type) {
        case SET_GDC:
            return { ...state, gdc: action.payload }
        case SET_SUBJECT:
            return { ...state, subjectList: action.payload }
        case SET_TOPIC:
            return { ...state, topicList: action.payload }
        case SET_CONDITION:
            return { ...state, conditionList: action.payload }
        case SET_AUTHORIZE:
            return { ...state, authorize: action.payload }
        case SET_USER:
            return { ...state, user: action.payload }
        case SET_AMOUNT:
            return { ...state, amount: action.payload }
        case SET_TYPE:
            return { ...state, type: action.payload }
        case SET_DOA:
            return { ...state, doa: action.payload }
        case SET_SEARCH:
            return { ...state, search: action.payload }
        case SET_ACTION:
            return { ...state, action: action.payload }
        case SET_BOOK:
            return { ...state, bookCode: action.payload }
        case SET_SEARCH_NAME:
            return { ...state, name: action.payload }
        case SET_ORG:
            return { ...state, orgList: action.payload }
        case SET_BOOK_DETAIL:
            return { ...state, bookDetail: action.payload }
        case SET_QUERY:
            return { ...state, [action.payload.key]: action.payload.value }
        case SET_SELECTED_TOPIC:
            return { ...state, selectedTopic: action.payload }
        case RESET_DOA:
            return INIIAL_STATE;
        default:
            return state;
    }
}